/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingShopAllLink_storyTellingTab = {
    readonly browseLink: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly tabType: string;
    readonly contentHeader: string;
    readonly contentCreatorAttribution: {
        readonly __typename: string;
    } | null;
    readonly " $refType": "PdpSharedStorytellingShopAllLink_storyTellingTab";
};
export type PdpSharedStorytellingShopAllLink_storyTellingTab$data = PdpSharedStorytellingShopAllLink_storyTellingTab;
export type PdpSharedStorytellingShopAllLink_storyTellingTab$key = {
    readonly " $data"?: PdpSharedStorytellingShopAllLink_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingShopAllLink_storyTellingTab">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedStorytellingShopAllLink_storyTellingTab",
  "type": "StoryTellingTab",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseLink",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentHeader",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contentCreatorAttribution",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '64654ae7fd4808aff58aefb40b743e06';
export default node;
